import { render } from "./OverdueReasons.vue?vue&type=template&id=e58e4078"
import script from "./OverdueReasons.vue?vue&type=script&lang=js"
export * from "./OverdueReasons.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__